export default __webpack_public_path__ + "static/media/warning.55a04855.svg";